export default "__VITE_ASSET__D2lyZqVk__"